const routes = {
  createCategory: 'category',
  getCategories: 'category',
  getCategoryById: 'category/',
  updateCategory: 'category/',
  deleteCategory: 'category/',
};

export default routes